import React from "react";
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AboutMain = () => {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <div style={styles.headerContainer}>
                <button onClick={() => navigate(-1)} style={styles.backButton}>
                    <ArrowBackIcon style={styles.backIcon} />
                </button>
                <h4 style={styles.heading}>About New Life Covenant Church</h4>
            </div>
            
            <div style={styles.contentContainer}>
                <div style={styles.block}>
                    <h5 style={styles.subHeading}>Who we are and what we believe in</h5>
                    <p style={styles.paragraph}> 
                    New Life Covenant Church is a Pentecostal Church with grace and commitment to sound doctrine and Bible based teaching. NLCC places Jesus Christ at the centre of the ministry and our Faith in God is uncompromising. These are our Non-Negotiables. Essentially they are at the centre of everything we do, unite us as a ministry
                    </p>
                </div>
                
                <div style={styles.block}>
                    <h5 style={styles.subHeading}>A place to belong</h5>
                    <p style={styles.paragraph}>
                    Welcome to New Life Covenant Church! Whether you’ve attended church since your infancy days or are just beginning to explore the idea, we’re here to give support to you through biblical teaching, inspiring worship and fellowship which we are certain will draw you incredibly close to Christ that your life will be transformed. The transformation approach at NLCC is holistic: spirit, body, mind and heart, and our values, beliefs and culture reflect that.
                    </p>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        padding: '18px',
        maxHeight: '600px',
        overflowY: 'scroll',
        backgroundColor: '#fff'
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginBottom: '15px',
        position: 'relative'
    },
    backButton: {
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        borderRadius: '50%',
        marginRight: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s ease',
        ':hover': {
            backgroundColor: '#f0f2f5'
        }
    },
    backIcon: {
        color: '#1a6363',
        fontSize: '28px'
    },
    heading: {
        flex: 1,
        textAlign: 'center',
        fontSize: '19px',
        color: '#1a6363',
        fontWeight: '600',
        margin: 0,
        paddingRight: '52px'
    },
    contentContainer: {
        padding: '0 8px'
    },
    block: {
        marginBottom: '25px'
    },
    subHeading: {
        fontSize: '18px',
        marginTop: '18px',
        color: '#1a6363',
        marginBottom: '12px'
    },
    paragraph: {
        textAlign: 'justify',
        lineHeight: '1.6',
        color: '#333',
        fontSize: '15px'
    }
};

export default AboutMain;
